//@flow
import * as React from 'react';
import classnames from 'classnames';
import theme from './EffectiveStatusDropdown.scss';
import { type ContractStatusEnum } from 'common/models/flow/MasterContract';

type Props = {
    children: ContractStatusEnum,
    innerProps: $FixMe
};

const buttonColorMapping = {
    DRAFT: theme.draftCircle,
    READY: theme.readyCircle,
    VERIFY: theme.verifyCircle,
    ACTIVE: theme.activeCircle,
    INACTIVE: theme.inactiveCircle,
    VOID: theme.voidCircle,
    EXPIRED: theme.expiredCircle
};
const EffectiveStatusOptions = (props: Props) => {
    const { children, innerProps } = props;
    return (
        <div {...innerProps} className={theme.optionsContainer}>
            <div>{children}</div>
            <div
                className={classnames(
                    theme.color,
                    buttonColorMapping[children]
                )}
            />
        </div>
    );
};

export default EffectiveStatusOptions;
